import { linkTo } from '../router';
import './legal.css';

/** Who runs Hearth, for the policies and the contact line on both pages. */
export const OPERATOR = 'Tarik Alauddin';
export const CONTACT_EMAIL = 'support@hearthservers.com';
/** When the Privacy Policy and Terms last changed: both pages show it. */
export const LEGAL_UPDATED = 'October 27, 2026';

/** The footer on every page, the landing's and the app's: a copyright line, the policies, and support. */
export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="wrap site-footer-inner">
        <p>© 2026 Hearth</p>
        <nav aria-label="Legal" className="site-footer-links">
          <a {...linkTo('/privacy')}>Privacy</a>
          <a {...linkTo('/terms')}>Terms</a>
          <a {...linkTo('/support')}>Support</a>
        </nav>
      </div>
    </footer>
  );
}
